export default {
	methods: {
		isImportant(resource) {
			return this.me && resource.saved_users && resource.saved_users.some(e => e.id === this.me.id)
		}
	}
}